// src/features/fourlink-config/hooks/useComments.js

import { useState, useCallback } from 'react';

export const buildCommentKey = (type, id) => `${type}:${String(id)}`;

export const useComments = () => {
  const [comments, setComments] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    targetKey: null,
    targetLabel: '',
    comment: ''
  });

  const hasComment = useCallback((key) => {
    return Boolean(key && typeof comments[key] === 'string' && comments[key].trim());
  }, [comments]);

  const openModal = useCallback((target) => {
    if (!target) return;

    const isObjectTarget = typeof target === 'object' && target !== null;
    const resolvedKey = isObjectTarget
      ? target.key || target.commentKey || target.targetKey || (target.id !== undefined ? buildCommentKey('tarea', target.id) : null)
      : null;

    if (!resolvedKey) return;

    const resolvedLabel = isObjectTarget
      ? target.label || target.name || target.tareaNombre || target.titulo || target.title || 'Elemento'
      : 'Elemento';

    setModalData({
      targetKey: resolvedKey,
      targetLabel: resolvedLabel,
      comment: comments[resolvedKey] || '',
    });
    setIsModalOpen(true);
  }, [comments]);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setModalData({ targetKey: null, targetLabel: '', comment: '' });
  }, []);

  const handleChange = useCallback((value) => {
    setModalData((prev) => ({ ...prev, comment: value }));
  }, []);

  const handleSave = useCallback(() => {
    setComments((prev) => {
      const updated = { ...prev };
      const trimmedComment = (modalData.comment || '').trim();
      const targetKey = modalData.targetKey;

      if (!targetKey) return updated;

      if (trimmedComment) {
        updated[targetKey] = trimmedComment;
      } else {
        delete updated[targetKey];
      }

      return updated;
    });

    closeModal();
  }, [modalData, closeModal]);

  return {
    comments,
    setComments,
    isModalOpen,
    modalData,
    hasComment,
    openModal,
    closeModal,
    handleChange,
    handleSave,
  };
};